import React from "react";
import { Form } from "react-crud-form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Input } from "ui/components/input";
import { Label } from "ui/components/label";
import { useNavigate } from "react-router-dom";
import { tagsSchema } from "./schema";
import { FormActions } from "components/form/actions";
import { useTagsForm } from "./useTagsForm";
import SelectColor from "components/select/color";
import SelectFor from "components/select/for";

const TagForm = ({ tagId }) => {

  const navigate = useNavigate();
  const { form, handleCreate, handleUpdate, handleRead } = useTagsForm({ tagId });

  return (
    <Form
      form={form}
      create={handleCreate}
      update={handleUpdate}
      read={handleRead}
      itemId={tagId || "+"}
      schema={tagsSchema}
    >
      {({
        isCreating,
        createItem,
        isNewItem,
        updateItem,
        isUpdating,
        isDirty,
      }) => (
        <div className="space-y-6">
          {/* Label Field */}
          <FormField
            control={form.control}
            name="label"
            render={({ field }) => (
              <FormItem>
                <Label required>Label</Label>
                <Input {...field} />
                <FormMessage />
              </FormItem>
            )}
          />

          {/* For */}
          <FormField
            control={form.control}
            name="for"
            render={({ field }) => (
              <FormItem>
                <Label required>For</Label>
                <SelectFor
                  collection="tags"
                  onValueChange={val => field.onChange(val)}
                  {...field}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          {/* Color */}
          <FormField
            control={form.control}
            name="color"
            render={({ field }) => (
              <FormItem>
                <Label>Color</Label>
                <SelectColor
                  collection="tags"
                  onValueChange={val => field.onChange(val)}
                  {...field}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          <FormActions
            isNewItem={isNewItem}
            isCreating={isCreating}
            isUpdating={isUpdating}
            isDirty={isDirty}
            createItem={() => createItem().then(() => navigate(-1))}
            updateItem={() => updateItem().then(() => navigate(-1))}
            showCancel={false}
            collection="tags"
            rule={isNewItem ? "create:*" : "update:*"}
          />
        </div>
      )}
    </Form>
  );
};

export default TagForm;
